import { AccountStatementsData } from './../account.model';
import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";
import { AccountStatementGenerationLabelPipe } from './pipes/account-statement-generation-label.pipe';

@Injectable()
export class AccountStatementsDataWidgetAdapter {
  constructor(
    private readonly datePipe: DatePipe,
    private readonly statementLabelPipe: AccountStatementGenerationLabelPipe,
  ) { }

  adaptListData = (data: AccountStatementsData, canViewAccountDocumentsGeneration: boolean): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Alligator data',
        customTemplateName: "aligatorDataValue"
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Statement generation',
        displayedValue: this.statementLabelPipe.transform(data),
        isItemHidden: !canViewAccountDocumentsGeneration
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Expires',
        displayedValue: this.datePipe.transform(data?.generateStatementsExpirationDate, "hh:mm a - MMM dd, yyyy"),
        isItemHidden: !canViewAccountDocumentsGeneration || !data?.generateStatements
      }),
    ]
  }
}